import { gql } from '@apollo/client';
import { Inv360SortOption } from '@lgg/isomorphic/types/__generated__/graphql';

export type { Inv360SortOption };

export const PER_PAGE = 20;

export const SORT_OPTIONS: Inv360SortOption[] = [
  'LATEST',
  'OLDEST',
  'HIGHER_PRICE',
  'LOWER_PRICE',
];

export const INV360_COMPANY_ENABLED_QUERY = gql`
  query Inv360CompanyEnabled($institutionId: Int!) {
    externalIntegrations {
      inv360CompanyEnabled(institutionId: $institutionId)
    }
  }
`;

export const INV360_VEHICLES_QUERY = gql`
  query Inv360Vehicles($input: Inv360ListVehiclesInput!) {
    externalIntegrations {
      inv360Vehicles(input: $input) {
        data {
          id
          title
          vin
          mileage
          formattedPrice
          thumbnailUrl
          daysInInventory
        }
        total
        page
        perPage
        totalPages
      }
    }
  }
`;

export const INV360_USERS_QUERY = gql`
  query Inv360Users($input: Inv360ListUsersInput!) {
    externalIntegrations {
      inv360Users(input: $input) {
        data {
          id
          fullName
        }
      }
    }
  }
`;

export const INV360_GENERATE_SHARE_LINK_MUTATION = gql`
  mutation Inv360GenerateShareLink($input: Inv360GenerateShareLinkInput!) {
    externalIntegrations {
      inv360GenerateShareLink(input: $input) {
        url
      }
    }
  }
`;
